<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    nudge-right="15px"
    offset-x 
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon   
        small     
        color="info"        
        v-on="on"
      >
        <v-icon>mdi-information-outline</v-icon>
      </v-btn> 
    </template>

    <v-card>
      <v-list
        dense
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Entitlement:</v-list-item-title>
            <v-list-item-subtitle>{{ (parseFloat(leaveEntitlement.entitled_days_taken || 0) + parseFloat(leaveEntitlement.carried_forward_days_taken || 0)+parseFloat(leaveEntitlement.available_days || 0)).toFixed(2) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Leave Utilized:</v-list-item-title>
            <v-list-item-subtitle>{{ (parseFloat(leaveEntitlement.entitled_days_taken || 0) + parseFloat(leaveEntitlement.carried_forward_days_taken || 0)).toFixed(2) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Leave Balance:</v-list-item-title>
            <v-list-item-subtitle>{{ leaveEntitlement.available_days ? parseFloat(leaveEntitlement.available_days).toFixed(2) : '0.00' }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <template v-if="leaveEntitlement.leave_type.is_carry_forwardable">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Brought Forward:</v-list-item-title>
              <v-list-item-subtitle :class="{'red--text': isExpired(leaveEntitlement.carried_forward_expiry_month)}">
                {{ leaveEntitlement.carried_forward_days || 0 }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Maximum Carry Forward Days:</v-list-item-title>
              <v-list-item-subtitle>{{ leaveEntitlement.maximum_carry_forward_amount || 0 }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      leaveEntitlement: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
      }
    },
    methods: {
      roundLeave (days) {
        return (days - Math.floor(days)) >= 0.5 ? Math.floor(days) + 0.5 : Math.floor(days)
      },
      isStarted (startDate) {
        return startDate <= this.$moment().format('YYYY-MM-DD')
      },
      isExpired (expiryMonth) {
        return expiryMonth <= (this.$moment().month() + 1)
      },
      getMonthName (i) {
        return this.$moment().month(i - 1).format('MMMM') 
      },
    },
  }
</script>
